import {
  Component,
  OnInit
} from '@angular/core';
import {
  RestService
} from '../rest.service';
import {
  AcuerdosService
} from '../acuerdos.service';
import { UserService } from '../user.service';

@Component({
  selector: 'app-crear-valor',
  templateUrl: './crear-valor.component.html',
  styleUrls: ['./crear-valor.component.scss']
})
export class CrearValorComponent implements OnInit {

  proveedor_index: string = '';

  datos: any[] = [];
  datos_load: boolean = false;

  acuerdos: any[] = [];
  acuerdo_id: string = '-';

  msg: string = '';
  desglose: any[] = [];

  detalle: any[] = [];

  valores_brutos: any[] = [];

  constructor(
    private rest: RestService,
    public user: UserService,
    public acuerdosService: AcuerdosService) {}

  ngOnInit() {}

  ActivarCambiarFechaValores(registro) { registro.activo = true; }

  CambiarFechaValores(registro) {

    const opcion = confirm('¿Quieres cambiar la fecha del registro?');

    if ( opcion ) {

      registro.activo = false;
      this.rest.CambiarFechaValores(registro.id, registro.creado)
      .subscribe(
        (data) => this.user.PublicMsg(data),
        (error) => this.user.PublicError(error) );
    }
  }

  SeleccionarAcuerdo() {
    this.desglose = [];
    this.acuerdos = this.acuerdosService.acuerdos[this.proveedor_index].acuerdos;
  }

  ObtenerValores() {
    this.rest.ObtenerValoresBrutos(
      this.acuerdosService.acuerdos[this.proveedor_index].acuerdos[this.acuerdo_id].id).subscribe
      ((data) => this.valores_brutos = data['data']);
  }

  SeleccionarDesglose() {
    if (this.acuerdosService.acuerdos[this.proveedor_index].acuerdos[this.acuerdo_id].desglose) {
      this.desglose = this.acuerdosService.acuerdos[this.proveedor_index].acuerdos[this.acuerdo_id].desglose;
    } else {
      this.user.PublicError('No tiene articulos añadidos');
    }

    this.ObtenerValores();

  }

  SeleccionarProducto(index) {

    this.detalle = this.acuerdosService
    .acuerdos[this.proveedor_index]
    .acuerdos[this.acuerdo_id].desglose[index];
  }

  SumarValores(detalle) {

    this.rest.SumarValores(detalle.id, detalle.input)
      .subscribe((data) => {
        this.user.PublicMsg(data);
        this.detalle['historial'].push({
          'id': detalle.id,
          'unidades': detalle.input,
          'creado': 'NUEVO REGISTRO'
        });
      },
      (error) => {
        this.user.PublicError(error);
      });

  }
  EliminarValores(detalle, index, historial) {

    const opcion = confirm('Estas seguro?');

    if (opcion) {
      this.rest.EliminarValores(detalle.id, )
        .subscribe(
        (data) => {
          this.user.PublicMsg(data);
          historial.splice(index, 1);
        },
        (error) => {
          this.user.PublicError(error);
        });
    }

  }

}
